import { render, staticRenderFns } from "./VisualizacionRadarArtistas.vue?vue&type=template&id=e71d16c4&scoped=true&"
import script from "./VisualizacionRadarArtistas.vue?vue&type=script&lang=js&"
export * from "./VisualizacionRadarArtistas.vue?vue&type=script&lang=js&"
import style0 from "./VisualizacionRadarArtistas.vue?vue&type=style&index=0&id=e71d16c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e71d16c4",
  null
  
)

export default component.exports